import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './index.css'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import App from './App.tsx'
import { initSentry } from './services/sentry';

// Initialize Sentry before React renders
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </I18nextProvider>
  </StrictMode>,
)
